import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import type { ErrorStateDetails } from '#src/app/shared/utils/async';
import { isError, isLoaded } from '#src/app/shared/utils/async';

import type { PolicyPageCombinedState, PolicyPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { PolicyPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<PolicyPageCombinedState> };

type Props = {
	slug: string | undefined;
	prefetchedData: PolicyPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const PolicyPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	slug,
	children,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(slug, prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return <PolicyPageDataContextProvider pageData={pageData}>{children}</PolicyPageDataContextProvider>;
};
